import React from 'react';
import PropTypes from 'prop-types';

const Popup = props => (
  props.open &&
    <div className="popup">
      <div className="popup-body">
        <span className="popup-content">{props.children}</span>
        <button type="button" onClick={() => props.onClose()} className="close" aria-label="Close">
          <span aria-hidden="true">&times;</span>
        </button>
      </div>
    </div>
);

Popup.propTypes = {
  open: PropTypes.bool,
  onClose: PropTypes.func,
  children: PropTypes.oneOfType([
    PropTypes.arrayOf(PropTypes.node),
    PropTypes.node,
  ]),
};

Popup.defaultProps = {
  open: false,
  onClose: null,
  children: null,
};

export default Popup;



// WEBPACK FOOTER //
// ./src/main/ui/react/product/src/components/Popup/Popup.js